<div class="row mx-0 p-2">
  <!-- Main groups -->
  <ng-content></ng-content>
  @if (!hideBrowseGroups) {
    <ul
      class="col group group-1 list-group browseGroups ps-3 ps-sm-0"
    [ngClass]="[
      productGroups.length || showPromotions
        ? isMobile
          ? 'd-none d-sm-flex'
          : 'col'
        : 'col',
      listClass
    ]"
      >
      @for (item of browseGroups; track item) {
        <li
          class="list-group-item"
      [ngClass]="{
        active: browseGroupItem && browseGroupItem.name === item.name
      }"
      (click)="
        browseGroupItem = item;
        showPromotionsBikes = false;
        item.sub_items && item.sub_items.length
          ? setProductGroup(item)
          : gotoToSearch()
      "
          >
          {{ item.description }}
        </li>
      }
      @if (
        showDealerOptions &&
        companyGroupsSettings &&
        companyGroupsSettings.bom_companies &&
        companyGroupsSettings.bom_companies.length
        ) {
        <li
          class="list-group-item"
          (click)="gotoToSearch('CMN_BOM')"
          >
          {{ "BOM" | translate }}
        </li>
      }
    </ul>
  }
  <!-- Product groups -->
  @if (!subGroups.length && productGroups.length) {
    <ul
      class="col group group-2 list-group productGroups scrollable customScrollbar"
      [ngClass]="listClass"
      [@inAnimation]
      [@pageAnimations]
      >
      <li class="list-group-item d-flex d-sm-none">
        <span
          class="btn btn-primary btn-rounded d-flex"
          (click)="productGroups = []; hideBrowseGroups = false"
          >
          {{ "BACK" | translate }}</span
          >
        </li>
        @for (item of productGroups; track item; let i = $index) {
          <li
            class="list-group-item first"
        (click)="
          productGroupItem = item;
          item.sub_items && item.sub_items.length > 1
            ? (subGroups = item.sub_items)
            : gotoToSearch()
        "
            >
            {{ item.description }}
          </li>
        }
        <li class="list-group-item all" (click)="gotoToSearch()">
          <span class="material-icons"> arrow_forward_ios </span
            >{{ "VIEW_ALL" | translate }}
          </li>
        </ul>
      } @else {
        <ng-content select="[carousel]"></ng-content>
      }

      <!-- Sub groups -->
      @if (subGroups && subGroups.length && !variationGroups.length) {
        <ul
          class="col group group-3 list-group subGroups scrollable customScrollbar"
          [ngClass]="listClass"
          [@inAnimation]
          >
          <li
            class="list-group-item d-flex border-bottom"
            (click)="subGroups = []; subGroupItem = null"
            >
            <span class="btn btn-primary d-flex btn-rounded">
              {{ "BACK" | translate }}</span
              >
              <span class="d-flex btn btn-text back-item text-start">{{
                productGroupItem.description
              }}</span>
            </li>
            @for (item of subGroups; track item) {
              <li
                class="list-group-item"
      (click)="
        subGroupItem = item;
        item.sub_items ? (variationGroups = item.sub_items) : gotoToSearch()
      "
                >
                {{ item.description }}
              </li>
            }
            <li class="list-group-item all" (click)="gotoToSearch()">
              <span class="material-icons"> arrow_forward_ios </span>
              {{ "VIEW_ALL" | translate }}
            </li>
          </ul>
        }
        <!-- Variation groups -->
        @if (variationGroups && variationGroups.length) {
          <ul
            class="col group group-3 list-group subGroups scrollable customScrollbar"
            [ngClass]="listClass"
            [@inAnimation]
            >
            <li
              class="list-group-item d-flex border-bottom"
              (click)="variationGroups = []; variationGroupItem = null"
              >
              <span class="btn btn-primary d-flex btn-rounded">
                {{ "BACK" | translate }}</span
                >
                <span class="d-flex btn btn-text back-item text-start">{{
                  subGroupItem.description
                }}</span>
              </li>
              @for (item of variationGroups; track item) {
                <li
                  class="list-group-item"
                  (click)="variationGroupItem = item; gotoToSearch()"
                  >
                  {{ item.description }}
                </li>
              }
              <li class="list-group-item all" (click)="gotoToSearch()">
                <span class="material-icons"> arrow_forward_ios </span>
                {{ "VIEW_ALL" | translate }}
              </li>
            </ul>
          }

          <!-- Promotion groups -->
          @if (showPromotions || (showPromotionsBikes && this.applicationService.getSelectCompanyGroupCode() === 'WG')) {
            <ul
              class="col group group-3 list-group scrollable customScrollbar"
              [ngClass]="listClass"
              [@inAnimation]
              >
              <li class="list-group-item d-flex d-sm-none">
                <span
                  class="btn btn-primary d-flex d-sm-none btn-rounded"
                  (click)="showPromotions = false; showPromotionsBikes = false; hideBrowseGroups = false"
                  >
                  {{ "BACK" | translate }}</span
                  >
                </li>
                @if (promotions && promotions.length) {
                  @for (groupedPromotions of promotions; track groupedPromotions) {
                    @for (item of groupedPromotions; track item) {
                      <li
                        class="list-group-item"
          (click)="
            gotoToSearch(
              'CMN_PROM&HOMEPROMO=' +
                item.promotioncode +
                '&COMPANY=' +
                +item.company_id,
              $event
            )
          "
                        >
                        {{ item.description ? item.description : item.title }}
                      </li>
                    }
                  }
                }
                @if (!promotionsLoaded && !productGroups.length) {
                  <li
                    class="list-group-item"
                    [@inAnimation]
                    >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </li>
                }
                @if (promotionsLoaded && !showPromotionsBikes) {
                  <li
                    class="list-group-item all"
      (click)="
        gotoToSearch(
          promotionPageUrl[applicationService.getSelectCompanyGroupCode() + '_PARTS']
        )
      "
                    [@inAnimation]
                    >
                    <span class="material-icons"> arrow_forward_ios </span>
                    {{ "VIEW_ALL" | translate }}
                  </li>
                }
                @if (promotionsLoaded && showPromotionsBikes) {
                  <li
                    class="list-group-item all"
      (click)="
        gotoToSearch(
          promotionPageUrl[applicationService.getSelectCompanyGroupCode() + '_BIKES']
        )
      "
                    [@inAnimation]
                    >
                    <span class="material-icons"> arrow_forward_ios </span>
                    {{ "VIEW_ALL" | translate }}
                  </li>
                }
              </ul>
            }

            @if (showPromotionsBikes && applicationService.getSelectCompanyGroupCode() !== 'WG') {
              <ul
                class="col group group-3 list-group scrollable customScrollbar"
                [ngClass]="listClass"
                [@inAnimation]
                >
                <li class="list-group-item d-flex d-sm-none">
                  <span
                    class="btn btn-primary d-flex d-sm-none btn-rounded"
                    (click)="showPromotionsBikes = false; hideBrowseGroups = false"
                    >
                    {{ "BACK" | translate }}</span
                    >
                  </li>
                  @if (['GHO'].includes(applicationService.getSelectCompanyGroupCode())) {
                    <li class="list-group-item all"
                      (click)="gotoToSearch('CMN_PROM&HOMEPROMO=ACCOF2&COMPANY=25')"
                      [@inAnimation]>
                      {{ "OFFERS" | translate }} | GHOST
                    </li>
                  }
                  @if (['GHO'].includes(applicationService.getSelectCompanyGroupCode())) {
                    <li class="list-group-item all"
                      (click)="gotoToSearch('CMN_PROM&HOMEPROMO=ACCOF3&COMPANY=25')"
                      [@inAnimation]>
                      {{ "OFFERS" | translate }} | LAPIERRE
                    </li>
                  }
                </ul>
              }
            </div>
